module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Chernobyl-S1.570c960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Chernobyl-S1.jpg
// module id = ZZm+
// module chunks = 0